import TextField from "@material-ui/core/TextField"
import React, { Fragment } from "react"
import { useFieldInputStyles } from "./styles"
import { useSwitch, useInputChange } from "Hooks/basic"
import { EndBtn } from "Types/material"
import { useEffect } from 'react'

const FieldInput = (props: {
    fieldName: string,
    label: string,
    onConfirm: (fieldName: string, text: string) => void,
    required?: boolean,
    disabled?: boolean,
    initialText?: string,
    endBtns?: EndBtn[],
    multiline?: boolean,
}) => {
    const classes = useFieldInputStyles()
    const { fieldName, multiline, label, onConfirm, required = true, disabled = false, initialText = "", endBtns = [] } = props
    const { text, handleChange, setText } = useInputChange(initialText)

    useEffect(() => {
        setText(initialText)
    }, [initialText])

    const {
        open: error,
        toggle,
    } = useSwitch(false)
    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value) {
            toggle(false)
            onConfirm(fieldName, event.target.value)
        } else {
            onConfirm(fieldName, "")
        }
        handleChange(event)
    }
    const handleBlur = () => {
        if (!text.trim()) {
            toggle(true)
        } else {
            toggle(false)
            onConfirm(fieldName, text)
        }
    }
    const linkStyle = text === ""
        ? { color: "rgba(0, 0, 0, 0.87)", cursor: "pointer", width: 50 }
        : { color: "#007fff", cursor: "pointer", width: 50  }
    return (
        <Fragment>
            <TextField
                className={classes.textWrap}
                required={required}
                fullWidth
                multiline={multiline || false}
                error={required && error}
                value={text}
                label={label}
                onChange={onChange}
                onBlur={handleBlur}
                disabled={disabled}
                InputProps={{
                    endAdornment: [(
                        endBtns ? endBtns.map((item: EndBtn, index: number) => {
                            return (
                                <p
                                    className={item.className}
                                    style={item.style}
                                    onClick={() => item.clickFunc && item.clickFunc(text)}>
                                    {item.name}
                                </p>
                            )
                        }): null
                    ),(
                        fieldName === "link" ? (
                            <p style={linkStyle} onClick={() => {
                                if (text) {
                                    window.open(text,"_blank")
                                }
                            }}>
                                跳转
                            </p>) : null
                    )],
                }}
            />
        </Fragment>
    )
}

export default FieldInput
